import { render, staticRenderFns } from "./localSvg.vue?vue&type=template&id=5042ebb9&scoped=true"
import script from "./localSvg.vue?vue&type=script&lang=js"
export * from "./localSvg.vue?vue&type=script&lang=js"
import style0 from "./localSvg.vue?vue&type=style&index=0&id=5042ebb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042ebb9",
  null
  
)

export default component.exports